<template>
  <div class="equity-box" v-show="pageShow">
    <van-form @submit="onSubmit" label-width="9em" ref="formService">
      <van-cell-group>
        <h3 class="cell_title">权益信息</h3>
        <van-field
          key="customerType"
          name="roleId"
          :value="roleId"
          label="权益信息"
        >
          <template #input>
            <p style="text-align: right; width: 100%">
              {{ pageTitle }}
            </p>
          </template>
        </van-field>
        <van-field
          v-if="$route.query.type == 1"
          class="required-label"
          name="permitPic"
          label="出版物经营许可证"
          :value="formObj.permitPic[0]"
          :rules="[{ required: true, message: '请上传出版物经营许可证' }]"
        >
          <template #input>
            <CellUpload type="" v-model="formObj.permitPic" />
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <div class="title-box">
          <h3 class="cell_title">商户信息</h3>
          <van-button
            class="btn"
            color="#4a79f1"
            plain
            round
            hairline
            native-type="button"
            @click="toServiceSign"
            >创建商户</van-button
          >
        </div>
        <van-field
          class="required-label"
          name="merchantName"
          v-model="formObj.merchantName"
          label="商户名称"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入商户名称' }]"
        />
        <van-field
          class="required-label"
          name="merchantNo"
          v-model="formObj.merchantNo"
          label="商户编号"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入商户编号' }]"
        />
      </van-cell-group>
      <div class="btn-box">
        <van-button
          class="form_btn"
          round
          block
          type="info"
          native-type="submit"
          :loading="btnLoding"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from "vant";
import CellUpload from "../components/CellUpload";
export default {
  name: "PartnerEquity",
  components: {
    CellUpload,
  },
  computed: {
    pageTitle() {
      switch (this.$route.query.type) {
        case "1":
          return "图书商城";
        case "2":
          return "学术会议";
        case "3":
          return "教育培训";
        case "4":
          return "行业报告";
        case "5":
          return "知识付费-会议论文集";
        case "6":
          return "知识付费-学术期刊";
        default:
          return "";
      }
    },
    roleId() {
      switch (this.$route.query.type) {
        case "1":
          return 9;
        case "2":
          return 10;
        case "3":
          return 11;
        case "4":
          return 12;
        case "5":
          return 14;
        case "6":
          return 15;
        default:
          return "";
      }
    }
  },
  data() {
    return {
      pageShow: false,
      btnLoding: false,
      formObj: {
        permitPic: [],
        merchantNo: "",
        merchantName: "",
      },
    };
  },
  created() {
    this.getPartnerDetail();
  },
  methods: {
    async getPartnerDetail() {
      const res = await this.$apis.userServe.getPartnerDetail();
      if (res.resultCode === "200") {
        let payMerchant = res.data.payMerchant;
        let businessList = res.content.businessList;
        let bid = this.$route.query.type;
        let businessDetail = businessList.filter((item) => item.bid === bid)[0];
        if (businessDetail.statusCode === 0 && payMerchant.mid) {
          this.formObj.merchantNo = payMerchant.mid;
          this.formObj.merchantName = payMerchant.merchantName;
        } else if (businessDetail.statusCode === 3) {
          this.formObj.permitPic = [businessDetail.permitPic];
          this.formObj.merchantNo = businessDetail.merchantNo;
          this.formObj.merchantName = businessDetail.merchantName;
        } else if (
          businessDetail.statusCode === 1 ||
          businessDetail.statusCode === 2 ||
          businessDetail.statusCode === 4
        ) {
          this.$router.replace({
            path: "/partner/equity-result",
            query: this.$route.query,
          });
        }
        this.pageShow = true;
      }
    },
    async toServiceSign() {
      const res = await this.$apis.zzsignServe.signProgress({ type: 2 });
      if (res.data && res.data.resCode === "0000") {
        const { applyStatus, umsRegId, applyStatusMsg } = res.data;
        switch (applyStatus) {
          case "00":
            this.$router.push(
              `/service-sign/agreement-sign?type=2&umsRegId=${umsRegId}`
            );
            break;
          case "05":
            this.$router.push(
              `/se  rvice-sign/public-verification?type=2&umsRegId=${umsRegId}`
            );
            break;
          case "02":
          case "03":
          case "04":
            this.$router.push(
              `/service-sign/sign-result?type=2&umsRegId=${umsRegId}`
            );
            break;
          default:
            Toast(applyStatusMsg);
            break;
        }
      } else {
        this.$router.push(`/service-sign?type=2`);
      }
    },
    async onSubmit(values) {
      this.btnLoding = true;
      let params = this.$global.deepClone(values);
      if (this.$route.query.type == 1) {
        params.permitPic = params.permitPic[0];
      }
      const res = await this.$apis.zzsignServe.equityApply(params);
      if (res.resultCode === "200") {
        this.$router.replace({
          path: "/partner/equity-result",
          query: this.$route.query,
        });
      } else {
        this.btnLoding = false;
        Toast(res.resultDesc);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.equity-box {
  padding: 12px;
  background-color: #f5f5f5;
  height: calc(100vh - constant(safe-area-inset-top) - 44px);
  height: calc(100vh - env(safe-area-inset-top) - 44px);

  &::v-deep .van-cell-group {
    margin-bottom: 12px;
    padding: 13px 12px 0;
    border-radius: 8px;
    overflow: hidden;

    .cell_title {
      font-size: 15px;
      color: #333333;
    }

    .van-cell {
      padding: 17px 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border: none;
      }

      .van-cell__title {
        color: #333333;
      }

      .van-field__control {
        text-align: right;
      }

      &::after {
        border: none;
      }
    }

    .van-field--error {
      position: relative;
      padding-bottom: 41px;

      .van-cell__title,
      .van-cell__value {
        position: unset;
      }

      .van-field__error-message {
        position: absolute;
        left: 0;
        // text-align: right;
      }

      .van-field__control {
        color: #333;

        &::placeholder {
          color: #333;
        }
      }
    }

    .required-label {
      .van-field__label {
        span {
          &::after {
            content: "*";
            color: red;
          }
        }
      }
    }
  }
}

.btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  padding-top: 6px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 6px) !important;
  padding-bottom: calc(env(safe-area-inset-bottom) + 6px) !important;
  width: 100vw;
  background-color: #fff;
  .form_btn {
    margin: 0 auto;
    width: 345px;
    height: 44px;
    background: #4a79f1;
    border-radius: 22px;
  }
}

.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    height: 28px;
  }
}
</style>
